import { BasePage } from "@/constants/site-builder";
import { createSiteBasePageURL } from "@/utils/url/createSiteBasePageURL";
import { createSitePathURL } from "@/utils/url/createSitePathURL";
import type { Sponsor } from "../types";

export function getSponsorUrlData(sponsor: Sponsor, sitePath: string) {
  const url = sponsor.linkToExternalPageEnabled
    ? sponsor.url
    : createSitePathURL(
        sitePath,
        createSiteBasePageURL(BasePage.Sponsors, sponsor.path),
      );
  const openInNewTab = Boolean(
    sponsor.openInNewTabEnabled && sponsor.linkToExternalPageEnabled,
  );

  return {
    url,
    openInNewTab,
  };
}
